import React from 'react';
import { Icons } from './Icons';
import { ToastState } from '../types';

interface ToastProps {
  toast: ToastState;
}

export const Toast: React.FC<ToastProps> = ({ toast }) => {
  if (!toast.show) return null;

  return (
    <div className="fixed top-6 right-6 z-[300] animate-in slide-in-from-right">
      <div
        className={`${
          toast.type === 'danger' ? 'bg-red-600' : 'bg-emerald-600'
        } text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center space-x-3`}
      >
        {toast.type === 'danger' ? <Icons.XCircle /> : <Icons.CheckCircle />}
        <p className="font-bold text-sm">{toast.message}</p>
      </div>
    </div>
  );
};
